import { useState } from "react";
import { MenuItems } from "./MenuItems";
import { FetchingGraphDates } from "../../../global/GlobalFcn";
import { rqx } from "../../../../../../core/request/API";
import { env } from "../../../../../../core/Env";
import moment from "moment";

export const GenerateInterval = ({platform, __SESSION, usage_state, anchorEl, setAnchorEl, open, department, allUsers}) => {

    const { form, graphDatasets } = usage_state 
    const [selectUser, setSelectUser] = useState([])

    const handleClose = () => setAnchorEl(null);

    const inputHandler = async(e, val, key) => {
        let name
        let value

        if (key === '' ) {
            name = e.target.name
            value = e.target.value
        }else{
            name = key;
            value = (val === null ? 0 : (val.id > 0 ? val.id:val));
        }
        
        const state = {...form.data}
        
        if (name === 'department') {
            let res = allUsers.filter((v) => { return v.company_department_id === value })
            setSelectUser(res)
            state['employee'].value = 0
            state['employee'].stat = false
            state['employee'].msg = ''
        }

        if (name === 'employee') {
            let uaccess = await rqx.get(`<<global>>/${env()}/roleaccess/uap`, {aid: window.btoa(`account_${value}`), tid:parseInt(process.env.REACT_APP_TID_BIZ)})
            state['employee']['role_id'] = uaccess?uaccess[0].role_id:0
            state['employee']['role_name'] = uaccess?uaccess[0].role_name:''
            state['employee']['first_name'] = val?val.first_name:''
            state['employee']['last_name'] = val?val.last_name:''
        }

        const intval = form.data.interval.value
        if (name === 'sequence' && value < 1) return 
        state[name].value = value
        state[name].stat = false
        state[name].msg = ''
        
        const final_data = name === 'interval' ? value !== intval ? {...state, date:{value:null, stat:state.date.stat, msg:state.date.msg} } : {...state} : {...state}

        form.set(final_data)
    }

    const generateHandler = async() => {

        let state = {...form.data}
        let validator = 0

        if (form.data.department.value > 0) {
            if (form.data.employee.value > 0) {
                state.employee.stat = false
                state.employee.msg = ''
            }else{
                state.employee.stat = true
                state.employee.msg = 'Interval is required!'
                validator+=1
            }
        }
    
        if (form.data.interval.value === '') {
            state.interval.stat = true
            state.interval.msg = 'Interval is required!'
            validator+=1
        } else {
            state.interval.stat = false
            state.interval.msg = ''
        }

        if (form.data.quarter.value === '') {
            state.quarter.stat = true
            state.quarter.msg = 'Quarter is required!'
            validator+=1
        } else {
            state.quarter.stat = false
            state.quarter.msg = ''
        }

        if (form.data.sequence.value === '') {
            state.sequence.stat = true
            state.sequence.msg = 'Sequence is required!'
            validator+=1
        } else {
            state.sequence.stat = false
            state.sequence.msg = ''
        }

        if (form.data.order.value === '') {
            state.order.stat = true
            state.order.msg = 'Order is required!'
            validator+=1
        } else {
            state.order.stat = false
            state.order.msg = ''
        }

        if (form.data.date.value === '' || form.data.date.value === null) {
            state.date.stat = true
            state.date.msg = 'Date is required!'
            validator+=1
        } else {
            state.date.stat = false
            state.date.msg = ''
        }
        
        form.set(state)
        if (validator === 0) {
            handleClose()
            let res_dates = await FetchingGraphDates(form.data.interval.value, parseInt(form.data.sequence.value), form.data.order.value, moment(form.data.date.value).format("MM-DD-YYYY"), form.data.quarter.value)
            graphDatasets.set((prev) => ({...prev, 
                ...res_dates,
                assigned_id:form.data.employee.value,
                first_name:form.data.employee.first_name,
                last_name:form.data.employee.last_name,
                middle_name:'',
                role_id:form.data.employee.role_id,
                role_name:form.data.employee.role_name,
            }))
        }
    }
 
    return (
        <MenuItems 
            platform={platform}
            role={__SESSION.data.uaccess[0]?.role_name !== 'Regular User'} //IF PERSONAL KINDLY REMOVE role params
            form={form}
            open={open} 
            anchorEl={anchorEl}
            handleClose={handleClose}
            inputHandler={inputHandler}
            generateHandler={generateHandler}
            department={department}
            selectUser={selectUser}
        />
    )
}